import { render, staticRenderFns } from "./ShapeForm.vue?vue&type=template&id=4a42592f&"
import script from "./ShapeForm.vue?vue&type=script&lang=js&"
export * from "./ShapeForm.vue?vue&type=script&lang=js&"
import style0 from "./ShapeForm.vue?vue&type=style&index=0&id=4a42592f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports